import { useEffect } from "react";
import { Head } from "@inertiajs/react";
import { hairbookSalonUrl } from "@/lib/_url/_external";

interface Props {
  salon?: {
    id: number;
    name: string;
    instagramUrl: string | null;
  };
  to: "hairbook" | "instagram";
}

function redirectUrl(salon: Props["salon"], to: Props["to"]): string | null {
  if (!salon) return null;
  if (to === "hairbook") return hairbookSalonUrl(salon.id);
  if (to === "instagram") return salon.instagramUrl;
  return null;
}

export default function SalonjobsRedirect({ salon, to }: Props) {
  const url = redirectUrl(salon, to);

  useEffect(() => {
    if (url) window.location.href = url;
  }, [url]);

  if (!salon || !url) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#fafaf7] text-[#0a0a0a] font-serif">
        <div className="text-center">
          <h1 className="text-xl mb-4">リンクが存在しません</h1>
          <a href="/salons" className="text-sm text-black/50 underline">トップへ戻る</a>
        </div>
      </div>
    );
  }

  return (
    <>
      <Head>
        <title>{`${salon.name} - 外部サイトへ移動`}</title>
        <meta httpEquiv="refresh" content={`0;url=${url}`} />
      </Head>

      <div className="min-h-screen flex items-center justify-center bg-[#fafaf7] text-[#0a0a0a] antialiased p-5">
        <p className="text-sm text-black/40 font-light">移動中...</p>
      </div>
    </>
  );
}
